<div class="one-right-panel">
  <div class="one-user-info">
    <div class="one-user-name">{{fullName}}</div>
    <div class="one-user-email">{{'@' + getUsername(userInfo)}} - {{ userInfo.email }}</div>
  </div>
  <div class="one-user-action">
    <div class="one-user-action-title">{{'rightPanel.actions.userInfo' | translate }}</div>
    <div class="one-user-action-items">
      <div class="one-user-action-item" [routerLink]="['/userDetails/me']" routerLinkActive="activate">
        <span class="fas fa-cog"></span>
        <span class="title">{{'rightPanel.actions.account' | translate }}</span>
      </div>
      <div class="one-user-action-item" >
        <span class="fas fa-edit"></span>
        <span class="title">{{'rightPanel.actions.edit' | translate }}</span>
      </div>
      <!-- <div class="one-user-action-item">
        <span class="fas fa-language"></span>
        <span class="title">{{'rightPanel.actions.language' | translate }}</span>
      </div> -->
      <div class="one-user-action-item" (click)="changeUserPassword()" *ngIf="isExternal == false">
        <span class="fas fa-info-circle"></span>
        <span class="title">{{'rightPanel.actions.changePassword' | translate }}</span>
      </div>
      <!-- <div class="one-user-action-item">
        <span class="fas fa-palette"></span>
        <span class="title">{{'rightPanel.actions.changeColor' | translate }}</span>
      </div> -->
    </div>
  </div>

  <div class="one-user-action" *ngIf="isAdmin">
    <div class="one-user-action-title">{{'rightPanel.manager.title' | translate }}</div>
    <div class="one-user-action-items">
      <div class="one-user-action-item" [routerLink]="['/management/userTitles']" routerLinkActive="activate">
        <span class="fas fa-cog"></span>
        <span class="title">{{'rightPanel.manager.actions.userTitle' | translate }}</span>
      </div>
    </div>
  </div>

</div>
